import { render, staticRenderFns } from "./AdvertisementNew.vue?vue&type=template&id=4d682295&"
import script from "./AdvertisementNew.vue?vue&type=script&lang=js&"
export * from "./AdvertisementNew.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports